import { RootState, store } from '../../index';
import { IDLE_STATUS } from '../../../utils/types/statuses';
import { TSelectOptions } from '../../../components/common/selects/common/types';

export const checkCanLoadExpertises = (cb: () => void): void => {
  const { expertises } = store.getState();
  if (expertises.status === IDLE_STATUS) {
    cb();
  }
};

export const getExpertisesForSelect = (state: RootState): TSelectOptions =>
  state.expertises.data.map((country) => ({
    value: country.id,
    label: country.name,
  }));

export const getExpertisesLabelsUsingIds = (
  ids: Array<number>,
): Array<string> => {
  const { expertises } = store.getState();
  const optionsObj = {};
  expertises.data.forEach((option) => {
    // @ts-ignore
    optionsObj[option.id] = option;
  });

  // @ts-ignore
  return ids.map((id) => optionsObj[id]?.name);
};
